//
//  ElementPropertyOption.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
import { ColorToken } from "../tokens/SDKColorToken";
import { parseToRgba, toHex } from "color2k";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
export const badgeColorValues = {
    blue: "#EFF7FF",
    cyan: "#E8FCFF",
    fuchsia: "#FFECFF",
    green: "#EAFDEF",
    grey: "#F5F9FF",
    lightGrey: "#F9F9F9",
    orange: "#FFF4E8",
    pink: "#FFEDFA",
    purple: "#FAF3FF",
    red: "#FFEDED",
    teal: "#E8FDFA",
    yellow: "#FFFEE8",
    blueSolid: "#2B7FFF",
    cyanSolid: "#00D3F2",
    fuchsiaSolid: "#E12AFB",
    greenSolid: "#31DE69",
    greySolid: "#62748E",
    lightGreySolid: "#D4D4D4",
    orangeSolid: "#FF8904",
    pinkSolid: "#F6339A",
    purpleSolid: "#8E51FF",
    redSolid: "#FB2E27",
    tealSolid: "#00D5BE",
    yellowSolid: "#FCC801",
    custom: null,
};
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class ElementPropertyOption {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a;
        this.id = model.id;
        this.name = model.name;
        const remoteColor = ((_a = model.backgroundColor) === null || _a === void 0 ? void 0 : _a.value) || "#FFFFFF";
        this.backgroundColor = remoteColor
            ? ElementPropertyOption.toHex8(remoteColor)
            : null;
    }
    static toHex6(rawColor) {
        const rgba = parseToRgba(rawColor);
        return toHex(`rgba(${rgba[0]}, ${rgba[1]}, ${rgba[2]}, 1)`).toUpperCase();
    }
    static toHex8(rawColor) {
        const rgba = parseToRgba(rawColor);
        return toHex(`rgba(${rgba[0]}, ${rgba[1]}, ${rgba[2]}, ${rgba[3]})`).toUpperCase();
    }
    /** Constructs directly manipulable update object for property option */
    toUpdateObject() {
        var _a;
        return {
            id: this.id,
            name: this.name,
            backgroundColor: {
                value: (_a = ColorToken.colorStringToNormalizedServerValue(this.backgroundColor, false)) !== null && _a !== void 0 ? _a : ColorToken.normalizedDefaultServerValue(),
            },
        };
    }
    /** Returns background color represented as badge color.
     * If badge color is different from what badge defines as base, return `custom`.
     * */
    asBadgeColor() {
        var _a;
        // Normalize current hex coming from BE and ignore alpha which is not supported by the badge
        if (!this.backgroundColor) {
            return "custom";
        }
        // Get badge color name where the hex matches
        const badgeColorName = (_a = Object.keys(badgeColorValues).find((colorName) => {
            const badgeColor = badgeColorValues[colorName];
            return badgeColor === this.backgroundColor;
        })) !== null && _a !== void 0 ? _a : "custom";
        return badgeColorName;
    }
    /**
     * Sets background color from hex color or badge color name.
     * @param color - Hex color or badge color name
     */
    setBackgroundColor(color) {
        const badgeColor = badgeColorValues[color];
        if (badgeColor) {
            this.backgroundColor = badgeColor;
        }
        else {
            this.backgroundColor = ElementPropertyOption.toHex8(color);
        }
    }
}
